import { ReactElement } from 'react';

import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { Advertiser } from 'components/common/types/Deal.types';
import usePendoTracking from 'customHooks/usePendoTracking';
import { AdvertiserFilters, FilterAdvertiserProps } from './FilterAdvertiser.types';
import { useLoadLookup } from '../useLoadLookup';

const FilterAdvertiser = <T extends AdvertiserFilters>({
  changeFilters,
  selectedAdvertiser,
}: FilterAdvertiserProps<T>): ReactElement => {
  const { onAssetLookup } = useLoadLookup();

  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  const onSelect: SelectHandler<Advertiser> = (_, advertiser: Advertiser): void => {
    const newFilters: Partial<T> = {};
    newFilters.advertiser = advertiser;
    changeFilters(newFilters);
  };

  return (
    <AsyncSelect
      dataTestId="advertiser-filter"
      name="advertiser"
      loadData={onAssetLookup}
      onSelect={onSelect}
      selectedValue={selectedAdvertiser}
      placeholder="Search advertiser"
      dataPendoId={getPendoDataId('Advertiser filter')}
    />
  );
};

export default FilterAdvertiser;
